export default __webpack_public_path__ + "static/media/title.5511e54e.png";